module Meevo.Plugins.Register {
    "use strict";

    export class CheckPaymentsSection extends Meevo.Plugins.Register.RegisterPaymentSectionBase {
        payment: Model.SaleCheckPayment;

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.Check, registerContext, "checkPayments", Register.RegisterSectionCatTypeEnum.Payment);
        }

        addPayment() {
            if (this.payment.checkNumber.toString().trim() == "") {
                return;
            }

            super.addPayment();
        }

        reset() {
            let paymentType = _.findWhere(this.registerContext.paymentTypes, { paymentCategory: Model.PaymentCategoryEnum.Check });
            this.payment = {
                __type: "Millennium.Meevo.Register.Contracts.Model.SalePaymentCheck, Millennium.Meevo.Register.Contracts.Model",
                paymentTypeId: paymentType.id,
                amount: 0,
                paymentCategory: Model.PaymentCategoryEnum.Check,
                checkNumber: "",
            };
        }
    }
}